import React from "react";
import { Text } from "native-base";
import { webFont } from "../../../Universal/API/API";

type SectionTitleProps = {
  scaleAll: number;
  text: string;
  marginTop?: number;
};

const SectionTitle: React.FC<SectionTitleProps> = ({ scaleAll, text, marginTop = 0 }) => {
  return (
    <Text
      selectable={false}
      style={{
        fontFamily: webFont("Inter"),
        fontSize: 11 * scaleAll,
        color: "#7A746C",
        fontWeight: "700",
        textTransform: "uppercase",
        letterSpacing: 0.6,
        marginTop,
        marginBottom: 8 * scaleAll,
      }}
    >
      {text}
    </Text>
  );
};

export default React.memo(SectionTitle);
